<script lang="ts">
  export let type: string;
  export let href: string;
</script>

<a {href} class="search-item">
  <div class="icon">
    <slot name="icon" />
  </div>
  <span class="content">
    <slot />
  </span>
  <span class="type">{type}</span>
</a>

<style lang="postcss">
  .search-item {
    display: flex;
    place-items: center;
    text-decoration: none;
    border-radius: var(--radius-2);
    padding: var(--space-3);
    padding-right: var(--space-5);
    font-size: var(--size-6);

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px var(--brand);
    }
  }
  .search-item:hover {
    background-color: var(--mauve-a3);
  }
  .search-item:focus {
    background-color: var(--mauve-a2);
  }

  .icon {
    border-radius: var(--radius-2);
    overflow: hidden;
    margin-right: var(--space-5);
    width: 3.2rem;
    height: 3.2rem;
  }

  .type {
    margin-left: auto;
    color: var(--mauve-a10);
    font-size: 0.9em;
  }
</style>
